import { useEffect, useState } from "react";
import { useAuth } from "utils/auth";
import nookies from "nookies";
import Nudge from "./Nudge";
import Gate from "./Gate";
import cx from "classnames";
import styles from "./Paywall.module.scss";
import { useActiveTestGroup } from "utils/abTesting";

const Paywall = () => {
  const testGroup = useActiveTestGroup("Three-Article-Meter-Holdout");

  const [slidingDirection, setSlidingDirection] = useState<
    "none" | "up" | "down"
  >("none");
  const { hasPaywallAccess } = useAuth();
  const cookies = nookies.get();
  const articleViewsCookie = cookies.articleViews || "[]";
  const pageViews = JSON.parse(articleViewsCookie).length;
  const [onClient, setOnClient] = useState<boolean>(false);

  //actual cap includes a view for gate -- 3 cap + 1 gate = 4
  let cap = 3;

  if (testGroup === "Three-Article-Meter-Holdout.3ArticleLimit") {
    cap = 4;
  }
  //cap for use in count displays
  const displayCap = cap - 1;

  const renderNudge = pageViews < cap;
  const renderGate = pageViews >= cap;

  useEffect(() => {
    setOnClient(true);
  }, []);

  //hasPaywallAccess means is a subscriber, display none
  if (hasPaywallAccess || !onClient) return null;

  return (
    <aside
      className={cx(
        styles.root,
        slidingDirection === "up" && styles.slideUp,
        slidingDirection === "down" && styles.slideDown
      )}
      id="paywall"
      data-testid="paywall"
      data-category="nudge interaction"
      data-label="paywall"
    >
      {renderGate && <Gate />}
      {renderNudge && (
        <Nudge
          cap={cap}
          displayCap={displayCap}
          pageViews={pageViews}
          setSlidingDirection={setSlidingDirection}
        />
      )}
    </aside>
  );
};

export default Paywall;
